import { useQuery } from '@tanstack/react-query';
import { getBusinessRegistrationNumbers } from '~apis/bank/getBusinessRegistrationNumbers';
import { useCompanyId } from '~hooks/useCompanyId';

export const USE_BUSINESS_REGISTRATION_NUMBERS_QUERY = {
  root: ['businessRegistrationNumbers'] as const,
  default: (companyId: string) =>
    [...USE_BUSINESS_REGISTRATION_NUMBERS_QUERY.root, companyId] as const,
};

export function useBusinessRegistrationNumbers() {
  const { companyId } = useCompanyId();

  return useQuery(
    USE_BUSINESS_REGISTRATION_NUMBERS_QUERY.default(companyId),
    () => getBusinessRegistrationNumbers(companyId),
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  );
}
